import React, { Component} from 'react';

import Select from '../../Select';

const data = [
    {value: 1, label: "评价方"},
    {value: 2, label: "评价分类"},
    {value: 3, label: "评价指标"}
];

const TargetType = (props) => (
    <Select name="targetType" label="请选择" data={data} {...props} ></Select>
);

export default TargetType;